import React from 'react';
import { PageCaptionLabel } from './styles';

const PageCaption = ({ label, children, isVisible }) => {
  return <PageCaptionLabel>{label || children}</PageCaptionLabel>;
};

export default PageCaption;
